import React from 'react';
const SvgIwm = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg id="iwm_svg__Layer_1" data-name="Layer 1" viewBox="0 0 26 30" width="1em" height="1em" {...props}>
      <defs>
        <radialGradient
          id="iwm_svg__radial-gradient"
          cx={15.716}
          cy={10.841}
          r={5.33}
          gradientTransform="matrix(1 0 0 6 0 -54.207)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#9bcae4" />
          <stop offset={0.076} stopColor="#9bcae4" />
          <stop offset={0.284} stopColor="#87b5d3" />
          <stop offset={0.295} stopColor="#86b4d2" />
          <stop offset={0.603} stopColor="#5f8daf" />
          <stop offset={0.848} stopColor="#47759a" />
          <stop offset={1} stopColor="#3e6c92" />
        </radialGradient>
        <radialGradient
          id="iwm_svg__radial-gradient-2"
          cx={13.123}
          cy={11.745}
          r={3.7}
          gradientTransform="matrix(1 0 0 3 0 -23.49)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#aae3ff" />
          <stop offset={0.186} stopColor="#83b8d8" />
          <stop offset={0.444} stopColor="#5181a6" />
          <stop offset={0.569} stopColor="#3e6c92" />
          <stop offset={0.857} stopColor="#7baac8" />
          <stop offset={1} stopColor="#9bcae4" />
        </radialGradient>
        <radialGradient
          id="iwm_svg__radial-gradient-3"
          cx={15.764}
          cy={12.263}
          r={6.116}
          gradientTransform="rotate(-95.2 10.165 18.394) scale(1 2)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#358cca" />
          <stop offset={0.034} stopColor="#358cca" />
          <stop offset={0.169} stopColor="#2d89c9" />
          <stop offset={0.365} stopColor="#2787c8" />
          <stop offset={0.691} stopColor="#0e74b5" />
          <stop offset={0.942} stopColor="#0069aa" />
          <stop offset={0.968} stopColor="#0069a3" />
          <stop offset={1} stopColor="#006994" />
        </radialGradient>
        <radialGradient
          id="iwm_svg__radial-gradient-4"
          cx={15.761}
          cy={13.312}
          r={5.476}
          gradientTransform="rotate(18.7 96.61 26.624) scale(1 3)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#005baa" />
          <stop offset={0.503} stopColor="#2787c8" />
          <stop offset={1} stopColor="#2787c8" />
        </radialGradient>
        <radialGradient
          id="iwm_svg__radial-gradient-5"
          cx={19.453}
          cy={18.737}
          r={0.905}
          gradientTransform="matrix(1 0 0 3 0 -37.474)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#669dd2" />
          <stop offset={0.184} stopColor="#669dd2" />
          <stop offset={0.995} stopColor="#2a5a72" />
          <stop offset={1} stopColor="#2a5a72" />
        </radialGradient>
        <style>{'.iwm_svg__cls-3{fill:#fff}.iwm_svg__cls-11{fill:#61aadb}'}</style>
      </defs>
      <g id="iwm_svg__assets">
        <path id="iwm_svg__foldedCorner" d="M22 1l7 7h-7z" transform="translate(-3 -1)" fill="#2787c8" />
        <path id="iwm_svg__background" d="M3 1v30h26V8h-7V1z" transform="translate(-3 -1)" fill="#257fbc" />
        <path id="iwm_svg__white" className="iwm_svg__cls-3" d="M4 2v20h24V8h-6V2z" transform="translate(-3 -1)" />
        <path
          id="iwm_svg__shadow"
          d="M29 15l-7-7h7z"
          transform="translate(-3 -1)"
          style={{
            isolation: 'isolate'
          }}
          fill="#1b3f63"
          opacity={0.2}
        />
        <g>
          <path
            className="iwm_svg__cls-3"
            d="M9.298 24.056h.882v4.902h-.882zM16.938 24.056l-.827 4.902h-1.24l-.826-4.125-.826 4.125h-1.247l-.847-4.902h.903l.617 4.153.847-4.153h1.134l.862 4.153.596-4.153zM22.629 24.056v4.902h-.848v-3.467l-1.037 3.46v.007h-.952l-1.064-3.613v3.613h-.785v-4.902h1.142l1.204 4.202 1.24-4.189-.007-.013z"
            transform="translate(-3 -1)"
          />
        </g>
        <g>
          <path
            d="M11.902 19.916v-2.268a2.36 2.36 0 001.243-.322 1.52 1.52 0 00.473-.484 3.488 3.488 0 00.348-1.752l.007-.272c.033-.837.097-5.478.097-6.725 0-.96-.15-.992-1.518-.992h-.234c-.24 0-.268-.126-.27-.165l-.018-2.111c0-.308.422-.341.604-.341.05 0 .082.002.083.002h6.657c.083 0 .189.017.216.094a.1.1 0 01.006.036l-.001.004v.004l.03 1.99-.244.488h-.942c-.928 0-1.001.44-1.001 1.014l-.01.763a389.408 389.408 0 00-.055 5.179l-.001.674c-.005 1.596-.008 2.325.334 2.667a1.221 1.221 0 00.921.25h.782c.031.274.045 1.347.046 2.075a.908.908 0 01-.166.093 2.293 2.293 0 01-.328.1z"
            transform="translate(-3 -1)"
            fill="#28c"
          />
          <path
            d="M11.777 4.826l.017 2.11v.005c.041-.24.225-.256.815-.256 1.214 0 1.843-.028 1.843 1.419 0 1.352-.089 7.478-.893 8.702a1.444 1.444 0 01-.452.462c1.53-.764 2.175-5.705 3.01-8.866a6.9 6.9 0 013.538-3.844c-.02-.06-.085-.14-.281-.14h-6.836s-.034-.003-.088-.003c-.201 0-.673.039-.673.41"
            transform="translate(-3 -1)"
            fill="url(#iwm_svg__radial-gradient)"
          />
          <path
            d="M12.609 6.685c-.59 0-.774.016-.814.256.002.033.028.23.34.23 1.574 0 1.866-.027 1.866.922 0 1.202-.063 5.867-.097 6.722a4.106 4.106 0 01-.345 1.99c.804-1.223.893-7.35.893-8.701 0-1.393-.583-1.419-1.708-1.419h-.135"
            transform="translate(-3 -1)"
            fill="url(#iwm_svg__radial-gradient-2)"
          />
          <path
            d="M16.118 8.402c-.836 3.161-1.482 8.102-3.01 8.866a2.32 2.32 0 01-1.275.312v2.388a7.141 7.141 0 003.529-3.113c1.07-2.295.2-6.751 1.742-9.223a1.567 1.567 0 011.637-.94c.255-.002.581-.052.949-.054l.004-.008-.03-2.007a.163.163 0 00-.009-.065 6.9 6.9 0 00-3.537 3.844"
            transform="translate(-3 -1)"
            fill="url(#iwm_svg__radial-gradient-3)"
          />
          <path
            d="M18.74 6.644a1.708 1.708 0 00-1.636.988c-1.543 2.472-.672 6.928-1.742 9.223a7.141 7.141 0 01-3.529 3.113v.018h7.343s-.057-2.4.498-2.498h-.84c-1.299 0-1.392-.503-1.392-3.522 0-2.2.065-5.587.065-5.85 0-.573.077-.945.932-.945h.984l.267-.533c-.368.002-.694.006-.95.006"
            transform="translate(-3 -1)"
            fill="url(#iwm_svg__radial-gradient-4)"
          />
          <path
            d="M19.176 19.985a2.419 2.419 0 00.348-.105.887.887 0 00.207-.122s-.003-2.063-.057-2.27c-.555.099-.498 2.497-.498 2.497"
            transform="translate(-3 -1)"
            fill="url(#iwm_svg__radial-gradient-5)"
          />
          <path
            className="iwm_svg__cls-11"
            d="M19.674 17.488l-.028.01a.257.257 0 00-.068.044.42.42 0 00-.078.1.942.942 0 00-.068.15 1.922 1.922 0 00-.055.188c-.017.068-.031.14-.045.216s-.025.154-.036.234a8.723 8.723 0 00-.051.487l-.018.236-.015.222-.012.199-.024.412-.01-.114a6.049 6.049 0 01-.012-.723c.004-.077.006-.157.012-.239.006-.08.012-.163.02-.246.01-.082.02-.165.032-.245a3.744 3.744 0 01.1-.455 1.495 1.495 0 01.07-.19.83.83 0 01.086-.15.404.404 0 01.094-.094.242.242 0 01.077-.036l.03-.006M19.655 4.558l-.126.076a12.46 12.46 0 00-1.042.703c-.054.04-.107.083-.163.126s-.11.088-.168.134c-.056.047-.115.095-.173.145a7.432 7.432 0 00-.71.691 5.815 5.815 0 00-.655.886 4.231 4.231 0 00-.46 1.079l-.147.592c-.05.198-.094.398-.14.598-.048.2-.092.4-.138.6l-.133.595-.259 1.158c-.087.376-.17.738-.259 1.08l-.063.254-.031.124-.033.12-.127.465-.03.11-.032.108-.063.206-.06.196-.061.184-.058.173c-.019.055-.036.109-.056.16l-.105.278-.045.12-.044.103-.071.162-.059.136.055-.138.065-.164.042-.104.042-.12.099-.281c.019-.05.034-.105.052-.16l.053-.174.058-.185.055-.197.06-.208.03-.107.028-.11.12-.465.032-.122.029-.124.06-.254c.083-.342.16-.706.247-1.081l.254-1.16.13-.596c.045-.2.088-.4.136-.6.047-.2.093-.401.143-.6l.15-.592a4.306 4.306 0 01.473-1.096 5.516 5.516 0 01.673-.889 7.487 7.487 0 01.724-.686 9.04 9.04 0 01.67-.51 12.477 12.477 0 01.902-.566l.129-.073"
            transform="translate(-3 -1)"
          />
          <path
            className="iwm_svg__cls-11"
            d="M11.833 19.967s.062-.026.176-.08a8.827 8.827 0 001.628-1.006 7.26 7.26 0 00.44-.374 5.831 5.831 0 00.856-.973 4.708 4.708 0 00.357-.61l.04-.082c.014-.03.028-.055.04-.083.026-.054.05-.11.072-.167.044-.115.082-.233.116-.354a9.813 9.813 0 00.265-1.526c.058-.526.097-1.064.136-1.6.04-.538.08-1.075.129-1.604s.109-1.048.191-1.548a9.158 9.158 0 01.34-1.42 3.876 3.876 0 01.593-1.164 2.079 2.079 0 01.42-.407 1.75 1.75 0 01.468-.239 1.876 1.876 0 01.453-.09c.035-.003.07-.003.105-.005H18.944l.74.009-.74.008-.186.001-.1.003c-.033.002-.068.003-.103.007a1.846 1.846 0 00-.445.096 1.714 1.714 0 00-.456.242 2.087 2.087 0 00-.406.403 3.826 3.826 0 00-.574 1.155 9.64 9.64 0 00-.325 1.413c-.08.497-.138 1.015-.185 1.543-.048.528-.085 1.065-.123 1.602a42.5 42.5 0 01-.14 1.603c-.03.264-.065.526-.108.783a7.138 7.138 0 01-.166.755 3.843 3.843 0 01-.194.532l-.04.082-.04.083a4.777 4.777 0 01-.37.614 5.887 5.887 0 01-.873.973 7.274 7.274 0 01-.875.675 8.814 8.814 0 01-1.224.674 5.547 5.547 0 01-.178.077"
            transform="translate(-3 -1)"
          />
        </g>
      </g>
    </svg>
  );
});
export default SvgIwm;
SvgIwm.iconName = 'iwm';
SvgIwm.displayName = 'SvgIwm';
